import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { SmUserAffiliationMapping_Create, SmUserAffiliationMapping_Create_External, SmUserAffiliationMapping_Delete, SmUserAffiliationMapping_GetResidentDetailBySocietyId, SmUserAffiliationMapping_GetTenantsByBuildingId, SmUserAffiliationMapping_OnDutySecurityStaff, SmUserAffiliationMapping_ReadAll, SmUserAffiliationMapping_ReadByBuildingId, SmUserAffiliationMapping_ReadByFlatId, SmUserAffiliationMapping_ReadById, SmUserAffiliationMapping_ReadBySocietyId, SmUserAffiliationMapping_ReadByUserId, SmUserAffiliationMapping_ReadGeneralStaffBySocietyId, SmUserAffiliationMapping_ReadUserBySocietyId, SmUserAffiliationMapping_Update,SmUserAffiliationMapping_ValidateCreateBulk,SmUserAffiliationMapping_CreateBulk  } from "src/app/GlobalVariable";
import { ResidentDetailList, ResidentDetailRequestDTO, ResidentDetailResponseDTO, SMUserAffiliationMappingCreateRequestDTO, SMUserAffiliationMappingDeleteRequestDTO, SMUserAffiliationMappingDTO, SMUserAffiliationMappingList, SMUserAffiliationMappingReadByBuildingIdRequestDTO, SMUserAffiliationMappingReadByFlatIdRequestDTO, SMUserAffiliationMappingReadByIdRequestDTO, SMUserAffiliationMappingReadBySocietyIdRequestDTO, SMUserAffiliationMappingReadByUserIdRequestDTO, SMUserAffiliationMappingUpdateRequestDTO, TenantDetailRequestDTO, TenantDetailList, SMUserAffiliationMappingReadUserBySocietyIdRequestDTO, SMUserList, SMUserAffiliationMappingReadGeneralStaffBySocietyIdRequestDTO, SMGeneralStaffUserList, SMUserAffiliationMappingOnDutySecurityStaffRequestDTO, SMUserAffiliationMappingValidateCreateBulkRequestDTO, SMUserAffiliationMappingValidateCreateBulkResponseDTO, SMUserAffiliationMappingCreateBulkRequestDTO, SMUserAffiliationMappingCreateBulkResponseDTO } from "./userAffiliationMapping.interface";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class UserAffiliationMappingService {
    private http = inject(HttpClient);

    SmUserAffiliationMapping_Create(data: SMUserAffiliationMappingCreateRequestDTO): Observable<SMUserAffiliationMappingDTO> {
        return this.http.post<SMUserAffiliationMappingDTO>(SmUserAffiliationMapping_Create, data);
    }

    SmUserAffiliationMapping_Create_External(
      data: SMUserAffiliationMappingCreateRequestDTO,
      xApiKey: string,
      xApiTimestamp: string,
      xApiNonce: string,
      xApiSignature: string
    ): Observable<SMUserAffiliationMappingDTO> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Api-Key': xApiKey,
        'X-Api-Timestamp': xApiTimestamp,
        'X-Api-Nonce': xApiNonce,
        'X-Api-Signature': xApiSignature
      });
      return this.http.post<SMUserAffiliationMappingDTO>(SmUserAffiliationMapping_Create_External, data, { headers });
    }

    SmUserAffiliationMapping_Update(data: SMUserAffiliationMappingUpdateRequestDTO): Observable<SMUserAffiliationMappingDTO> {
        return this.http.post<SMUserAffiliationMappingDTO>(SmUserAffiliationMapping_Update, data);
    }

    SmUserAffiliationMapping_Delete(data: SMUserAffiliationMappingDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SmUserAffiliationMapping_Delete, data);
    }

    SmUserAffiliationMapping_ReadAll(): Observable<SMUserAffiliationMappingList> {
        return this.http.get<SMUserAffiliationMappingList>(SmUserAffiliationMapping_ReadAll);
    }

    SmUserAffiliationMapping_ReadById(data: SMUserAffiliationMappingReadByIdRequestDTO): Observable<SMUserAffiliationMappingDTO> {
        return this.http.post<SMUserAffiliationMappingDTO>(SmUserAffiliationMapping_ReadById, data);
    }


    SmUserAffiliationMapping_ReadByUserId(data: SMUserAffiliationMappingReadByUserIdRequestDTO): Observable<SMUserAffiliationMappingList> {
        return this.http.post<SMUserAffiliationMappingList>(SmUserAffiliationMapping_ReadByUserId, data);
    }

    SmUserAffiliationMapping_ReadBySocietyId(data: SMUserAffiliationMappingReadBySocietyIdRequestDTO): Observable<SMUserAffiliationMappingList> {
        return this.http.post<SMUserAffiliationMappingList>(SmUserAffiliationMapping_ReadBySocietyId, data);
    }

    SmUserAffiliationMapping_ReadByBuildingId(data: SMUserAffiliationMappingReadByBuildingIdRequestDTO): Observable<SMUserAffiliationMappingList> {
        return this.http.post<SMUserAffiliationMappingList>(SmUserAffiliationMapping_ReadByBuildingId, data);
    }

    SmUserAffiliationMapping_ReadByFlatId(data: SMUserAffiliationMappingReadByFlatIdRequestDTO): Observable<SMUserAffiliationMappingList> {
        return this.http.post<SMUserAffiliationMappingList>(SmUserAffiliationMapping_ReadByFlatId, data);
    }

    SmUserAffiliationMapping_GetResidentDetailBySocietyId(data: ResidentDetailRequestDTO): Observable<ResidentDetailList> {
        return this.http.post<ResidentDetailList>(SmUserAffiliationMapping_GetResidentDetailBySocietyId, data);
    }

    SmUserAffiliationMapping_GetTenantByBuildingId(data: TenantDetailRequestDTO): Observable<TenantDetailList> {
        return this.http.post<TenantDetailList>(SmUserAffiliationMapping_GetTenantsByBuildingId, data);
    }

    SmUserAffiliationMapping_ReadUserBySocietyId(data: SMUserAffiliationMappingReadUserBySocietyIdRequestDTO): Observable<SMUserList> {
        return this.http.post<SMUserList>(SmUserAffiliationMapping_ReadUserBySocietyId, data);
    }


    SmUserAffiliationMapping_ReadGeneralStaffBySocietyId(data: SMUserAffiliationMappingReadGeneralStaffBySocietyIdRequestDTO): Observable<SMGeneralStaffUserList> {
        return this.http.post<SMGeneralStaffUserList>(SmUserAffiliationMapping_ReadGeneralStaffBySocietyId, data);
    }

    SmUserAffiliationMapping_OnDutySecurityStaff(data: SMUserAffiliationMappingOnDutySecurityStaffRequestDTO): Observable<SMUserList> {
        return this.http.post<SMUserList>(SmUserAffiliationMapping_OnDutySecurityStaff, data);
    }

    SmUserAffiliationMapping_ValidateCreateBulk(data: SMUserAffiliationMappingValidateCreateBulkRequestDTO): Observable<SMUserAffiliationMappingValidateCreateBulkResponseDTO> {
    return this.http.post<SMUserAffiliationMappingValidateCreateBulkResponseDTO>(SmUserAffiliationMapping_ValidateCreateBulk, data);
    }

    SmUserAffiliationMapping_CreateBulk(data: SMUserAffiliationMappingCreateBulkRequestDTO): Observable<SMUserAffiliationMappingCreateBulkResponseDTO> {
    return this.http.post<SMUserAffiliationMappingCreateBulkResponseDTO>(SmUserAffiliationMapping_CreateBulk, data);
    }

  
}